import {appName} from '../settings/constants'
import {createSelector} from 'reselect'
import {Record} from 'immutable'
import {arrayToMap, formatErrorMessage} from '../helpers/common'
import RestService from '../helpers/RestService'
import {currentSubjectSelector, moduleName as subjectModuleName} from './subjects'
import {DISABLED, ENABLED, _getId, _getIds, _trashedScopeCB, _isTrashed, _getEntity, _getEntityWithTrashed, _entities, _entitiesWithTrashed, _entitiesGroup, adjustEntitiesFieldsType} from './_utils'
import { SubmissionError } from 'redux-form'
import {ajaxUrls} from "../settings/routes"


/**
 * Constants
 * */
export const moduleName = 'sources'
const prefix = `${appName}/${moduleName}`

export const SOURCES_START = `${prefix}/SOURCES_START`
export const SOURCES_SUCCESS = `${prefix}/SOURCES_SUCCESS`
export const SOURCES_FAIL = `${prefix}/SOURCES_FAIL`
export const MASS_SOURCES_SUCCESS = `${prefix}/MASS_SOURCES_SUCCESS`
export const SOURCES_ENTITIES_CHANGE = `${prefix}/SOURCES_ENTITIES_CHANGE`
export const SOURCES_ENTITIES_DELETE = `${prefix}/SOURCES_ENTITIES_DELETE`
export const SET_SOURCES_CURSOR = `${prefix}/SET_SOURCES_CURSOR`


/**
 * Reducer
 * */

export const sourceRecord = Record({
    id : null,
    name : "",

    status : ENABLED,
})

export const ReducerRecord = Record({
    entities : arrayToMap([], sourceRecord),
    cursor : null,
})

const defaultState = new ReducerRecord();

export const reducer = (state = defaultState, action) => {
    const {type, payload} = action

    switch (type) {
        case SOURCES_SUCCESS : {
            let {sources} = payload
            return state.update('entities', currEntities => currEntities.merge(arrayToMap(sources, sourceRecord)))
            break
        }
        case MASS_SOURCES_SUCCESS : {
            let {sourcesData} = payload
            sourcesData.forEach(sdItem => {
                let {sources} = sdItem
                state = state.update('entities', currEntities => currEntities.merge(arrayToMap(sources, sourceRecord)))
            })
            return state
            break
        }
        case SET_SOURCES_CURSOR : {
            const {id} = payload
            return state.set("cursor", id)
            break
        }
        case SOURCES_ENTITIES_CHANGE : {
            const {sources = []} = payload
            sources.forEach(source => {
                const {id} = source
                state = state.setIn(["entities", id], new sourceRecord({...source}))
            })
            return state
            break
        }
        case SOURCES_ENTITIES_DELETE : {
            const {ids = []} = payload
            ids.forEach(id => {
                state = state.updateIn(["entities", id], source => source.set('status', DISABLED))
                if (state.get("cursor") === id) {
                    state = state.set("cursor", null)
                }
            })
            return state
            break
        }
        default : {
            return state
        }
    }
}

/**
 * Selectors
 * */

export const stateSelector = state => state[moduleName]
export const sourcesMapSelector = createSelector(stateSelector, state => state.entities)
export const sourcesSelector = createSelector(sourcesMapSelector, _entities)
export const sourcesWithTrashedSelector = createSelector(sourcesMapSelector, _entitiesWithTrashed)

export const sourcesCursorSelector = createSelector(stateSelector, state => state.cursor)
export const currentSourceSelector = createSelector(sourcesMapSelector, sourcesCursorSelector, _getEntity)

export const sourcesGroupSelector = createSelector(sourcesMapSelector, _getIds, _entitiesGroup)

export const sourceSelector = createSelector(sourcesMapSelector, _getId, _getEntity)
export const sourceWithTrashedSelector = createSelector(sourcesMapSelector, _getId, _getEntityWithTrashed)
export const createSourceSelector = () => sourceSelector
export const createSourceWithTrashedSelector = () => sourceWithTrashedSelector


export const currentSubjectSourcesSelector = createSelector(state => {
    const cursor = state[subjectModuleName].cursor
    const subjectsMap = state[subjectModuleName].entities
    return subjectsMap.get(cursor)
}, sourcesMapSelector, (subject, sourcesMap) => {
    if (!subject) return []
    const {sourcesIds} = subject
    return sourcesIds.keySeq().toArray().map(id => sourcesMap.get(id)).filter(_trashedScopeCB)
})

/**
 * Action Creators
 * */

export const setSourcesCursor = (id) => ({
    type : SET_SOURCES_CURSOR,
    payload : {
        id
    }
})

export const clearSourcesCursor = () => ({
    type : SET_SOURCES_CURSOR,
    payload : {
        id : null
    }
})

export const changeSourcesEntities = (params) => {
    const {sources, subjectId} = params
    return {
        type : SOURCES_ENTITIES_CHANGE,
        payload : {
            sources,
            subjectId
        }
    }
}

export const deleteSourcesEntities = (params) => {
    const {ids, subjectId} = params
    return {
        type : SOURCES_ENTITIES_DELETE,
        payload : {
            ids,
            subjectId
        }
    }
}

export const sourcesSucces = params => {
    const {sources, subjectId} = params
    return {
        type : SOURCES_SUCCESS,
        payload : {
            sources : adjustEntitiesFieldsType(sources),
            subjectId,
        }
    }
}

export const massSourcesSucces = params => {
    const {sourcesDataObj} = params
    let sourcesData = []

    Object.values(sourcesDataObj).forEach(sdoItem => {
        let {subjectId, sources} = sdoItem

        sourcesData = [
            ...sourcesData,
            {
                subjectId,
                sources : adjustEntitiesFieldsType(sources),
            }
        ]
    })

    return {
        type : MASS_SOURCES_SUCCESS,
        payload : {
            sourcesData,
        }
    }
}


/**
 * Thunk
 * */

export const checkAndUploadSources = (subjectId) => {
    return (dispatch, getState) => {
        const state = getState()
        /*if(!subjectId || typeof subjectId == 'undefined'){
            if(typeof window.state.tempForSave.subject_id == 'undefined'){
                return
            }
            subjectId = window.state.tempForSave.subject_id
        }*/
        const currentSubject = currentSubjectSelector(state, subjectId)
        //console.log(currentSubject);
        //if (!currentSubject) return
        //const {sourcesLoading} = currentSubject
        //if (sourcesLoading) return

        dispatch({
            type : SOURCES_START,
            payload : {
                subjectId
            }
        })
        RestService.postFormData(ajaxUrls.sourceList, `Branch=${JSON.stringify({branch_id: subjectId})}`)
            .then(res => {
                if (res.status >= 400) throw new Error(res.statusText)
                return res.json()
            })
            .then(sources => {
                dispatch(sourcesSucces({sources, subjectId}))
            })
            .catch(error => {
                dispatch({
                    type : SOURCES_FAIL,
                    payload : {
                        subjectId
                    }
                })
                console.warn(error) // TODO discuss with backend error handling
            })
    }
}


/*
 * Redux Form
 * */
export const handleCreateSource = (params) => {
    const {name, subjectId : branch_id,} = params
    let data = new FormData()
    data.append("Source", JSON.stringify({name, branch_id}))
    return RestService.bodyAsFormData(ajaxUrls.sourceCreate, data)
        .then(res => {
            if (res.status >= 400) {
                throw new SubmissionError({
                    _error : res.statusText,
                })
            }
            return res.json()
        })
        .then(res => {
            let {errcode, source, message} = res
            if (errcode === 200) {
                const {id, name} = source
                return {id, name}
            } else {
                throw new SubmissionError({
                    _error : formatErrorMessage(message),
                })
            }
        })
}

export const handleUpdateSource = (params) => {
    const {id, name} = params
    let data = new FormData()
    data.append("Source", JSON.stringify({id, name}))
    return RestService.bodyAsFormData(ajaxUrls.sourceUpdate, data)
        .then(res => {
            if (res.status >= 400) {
                throw new SubmissionError({
                    _error : res.statusText,
                })
            }
            return res.json()
        })
        .then(res => {
            let {errcode, source, message} = res
            if (errcode === 200) {
                const {id, name} = source
                return {id, name}
            } else {
                throw new SubmissionError({
                    _error : formatErrorMessage(message),
                })
            }
        })
}

export const handleDeleteSource = (params) => {
    const {id} = params
    return RestService.postFormData(ajaxUrls.sourceDelete, "Source=" + JSON.stringify({id}))
        .then(res => {
            if (res.status >= 400) {
                throw new SubmissionError({
                    _error : res.statusText,
                })
            }
            return res.json()
        })
        .then(res => {
            let {errcode, id : deletedId, message} = res
            if (errcode === 200) {
                return deletedId
            } else {
                throw new SubmissionError({
                    _error : formatErrorMessage(message),
                })
            }
        })
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/modules/sources.js